import axios from "axios";
import { useInfiniteQuery } from "@tanstack/react-query";

import { Keys } from "clients/apis/_keys";
import { Routes } from "clients/apis/_routes";

const countries = async (data: LocationReqT) => {
  const { name, pageParam } = data;
  const qs = `?page=${pageParam ?? 1}&q=${name ?? ""}`;
  return axios.get(Routes.COUNTRIES + qs);
};

export const useCountries = (params: LocationReqT) => {
  const { name } = params;
  return useInfiniteQuery({
    queryKey: [Keys.COUNTRIES_QRY, name],
    queryFn: ({ pageParam = 1 }) => countries({ pageParam, name }),
    getNextPageParam: (lastPage) => {
      return lastPage.data.links.next
        ? lastPage.data.meta.current_page + 1
        : null;
    },
    getPreviousPageParam: (firstPage) => firstPage.data.links.prev,
    cacheTime: 0,
    staleTime: 0,
  });
};
